import React from "react";

interface BadgeProps {
  children?: React.ReactNode;
  tone?: string;
}

export const Badge = ({ children, tone = "gray" }: BadgeProps) => {
  const colors = {
    gray: "bg-gray-100 text-gray-800",
    green: "bg-green-100 text-green-800",
    red: "bg-red-100 text-red-800",
    blue: "bg-blue-100 text-blue-800",
    amber: "bg-amber-100 text-amber-800",
  };
  // @ts-ignore
  const cls = colors[tone] || colors.gray;
  return (
    <span className={`inline-block text-xs px-2 py-0.5 rounded text-nowrap ${cls}`}>
      {children}
    </span>
  );
}